module.exports = __webpack_public_path__ + "static/media/car-top.d5e98c57.jpg";